export const hexToRgba = (hex: string, alpha?: number): string => {
	let r = 0
	let g = 0
	let b = 0
	if (hex?.match(/^#[0-9a-f]{6}$/i)) {
		r = parseInt(hex.slice(1, 3), 16)
		g = parseInt(hex.slice(3, 5), 16)
		b = parseInt(hex.slice(5, 7), 16)
	} else if (hex?.match(/^#[0-9a-f]{3}$/i)) {
		r = parseInt(hex.slice(1, 2).repeat(2), 16)
		g = parseInt(hex.slice(2, 3).repeat(2), 16)
		b = parseInt(hex.slice(3, 4).repeat(2), 16)
	}

	if (alpha) {
		return `rgba(${r},${g},${b},${alpha.toFixed(2)})`
	}
	return `rgba(${r},${g},${b},1)`
}
